import { memo } from 'react';
import { Form, Button } from 'react-bootstrap';
import { professionalsCss, buttonCss, inputCss } from '@digital_monorepo/styling';
import useInput from '@digital_monorepo/lib-common/hooks/useInput';

const ProfessionalForm = memo(({
  formData,
  onSubmit,
  onCancel,
  formType,
  isContractor,
  isSubmitting,
  hasError
}) => {
  const {
    ProfessionalID,
    ProfessionalName,
    FunctionLevel,
    FunctionName,
    Office,
    ProfessionalRC,
    area,
    idError,
    nameError,
    levelError,
    functionError,
    officeError,
    rcError,
    areaError,
    onIdChange,
    onNameChange,
    onLevelChange,
    onFunctionChange,
    onOfficeChange,
    onRcChange,
    onAreaChange,
    onIdBlur,
    onNameBlur,
    onLevelBlur,
    onFunctionBlur,
    onOfficeBlur,
    onRcBlur,
    onAreaBlur
  } = formData;

  return (
    <form onSubmit={onSubmit} className={professionalsCss.professionalForm}>
      <div className={`${idError ? inputCss.inputInformationError : inputCss.inputInformation}`}>
        <label htmlFor="ProfessionalID">Professional ID</label>
        <input
          id="ProfessionalID"
          type="text"
          className={`${idError ? inputCss.inputError : ''}`}
          value={ProfessionalID}
          onChange={e => onIdChange(e)}
          onBlur={onIdBlur}
          disabled={formType === 'edit' && !isContractor}
        />
        {idError && <p className={inputCss.errorText}>Professional ID is required</p>}
      </div>

      <div className={`${nameError ? inputCss.inputInformationError : inputCss.inputInformation}`}>
        <label htmlFor="ProfessionalName">Name</label>
        <input
          id="ProfessionalName"
          type="text"
          className={`${nameError ? inputCss.inputError : ''}`}
          value={ProfessionalName}
          onChange={e => onNameChange(e)}
          onBlur={onNameBlur}
        />
        {nameError && <p className={inputCss.errorText}>Name is required</p>}
      </div>

      <div className={`${levelError ? inputCss.inputInformationError : inputCss.inputInformation}`}>
        <label htmlFor="FunctionLevel">Function Level</label>
        <input
          id="FunctionLevel"
          type="text"
          className={`${levelError ? inputCss.inputError : ''}`}
          value={FunctionLevel}
          onChange={e => onLevelChange(e)}
          onBlur={onLevelBlur}
        />
        {levelError && <p className={inputCss.errorText}>Function Level is required</p>}
      </div>

      <div className={`${functionError ? inputCss.inputInformationError : inputCss.inputInformation}`}>
        <label htmlFor="FunctionName">Function Name</label>
        <input
          id="FunctionName"
          type="text"
          className={`${functionError ? inputCss.inputError : ''}`}
          value={FunctionName}
          onChange={e => onFunctionChange(e)}
          onBlur={onFunctionBlur}
        />
        {functionError && <p className={inputCss.errorText}>Function Name is required</p>}
      </div>

      <div className={`${officeError ? inputCss.inputInformationError : inputCss.inputInformation}`}>
        <label htmlFor="Office">Office</label>
        <input
          id="Office"
          type="text"
          className={`${officeError ? inputCss.inputError : ''}`}
          value={Office}
          onChange={e => onOfficeChange(e)}
          onBlur={onOfficeBlur}
        />
        {officeError && <p className={inputCss.errorText}>Office is required</p>}
      </div>

      <div className={`${rcError ? inputCss.inputInformationError : inputCss.inputInformation}`}>
        <label htmlFor="ProfessionalRC">Professional RC</label>
        <input
          id="ProfessionalRC"
          type="text"
          className={`${rcError ? inputCss.inputError : ''}`}
          value={ProfessionalRC}
          onChange={e => onRcChange(e)}
          onBlur={onRcBlur}
        />
        {rcError && <p className={inputCss.errorText}>Professional RC is required</p>}
      </div>

      <div className={`${areaError ? inputCss.inputInformationError : inputCss.inputInformation}`}>
        <label htmlFor="area">Area</label>
        <input
          id="area"
          type="text"
          className={`${areaError ? inputCss.inputError : ''}`}
          value={area}
          onChange={e => onAreaChange(e)}
          onBlur={onAreaBlur}
        />
        {areaError && <p className={inputCss.errorText}>Area is required</p>}
      </div>

      <div className={professionalsCss.actionButtons}>
        <Button
          type="submit"
          variant="success"
          className={`${buttonCss.primaryBtn} ${professionalsCss.adminButton}`}
          disabled={isSubmitting}
        >
          Save
        </Button>
        <Button
          variant="secondary"
          onClick={onCancel}
          className={`${buttonCss.secondaryBtn} ${professionalsCss.adminButton}`}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
      </div>
    </form>
  );
});

export default ProfessionalForm;